import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { useDispatch } from 'react-redux';
import CardFace from '../Card/CardFace';
import { viewCard } from '../Card/actions';
import { PlainButton } from '../Controls';
import { Cards } from './styled';

/** The cards a line of the log is about, as small pictures of the cards; a tap shows one full size. */
const LineCards = ({ cardIds, cardsById }) => {
  const dispatch = useDispatch();

  return (
    <Cards>
      {cardIds.map((id, i) => {
        const card = cardsById.get(id);
        if (!card) {
          return null;
        }
        return (
          <PlainButton key={i} onClick={() => dispatch(viewCard(card))} aria-label={`Show ${card.get('name')}`}>
            <CardFace card={card} />
          </PlainButton>
        );
      })}
    </Cards>
  );
};

LineCards.propTypes = {
  cardIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  cardsById: PropTypes.instanceOf(Map).isRequired,
};

export default LineCards;
